"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from "lucide-react";
interface GalleryNavigationButtonsProps {
  onPrevious: () => void;
  onNext: () => void;
  canGoPrevious: boolean;
  canGoNext: boolean;
  className?: string;
}
export function GalleryNavigationButtons(t0) {
  const $ = _c(11);
  const {
    onPrevious,
    onNext,
    canGoPrevious,
    canGoNext,
    className
  } = t0;
  let t1;
  if ($[0] !== canGoPrevious || $[1] !== className || $[2] !== onPrevious) {
    t1 = canGoPrevious && <button type="button" onClick={e => {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      onPrevious();
    }} onMouseDown={_temp} className={`flex absolute left-2 md:left-4 top-1/2 -translate-y-1/2 z-10 bg-black/10 hover:bg-black/30 text-white rounded-full p-2 md:p-3 shadow-lg transition-all duration-200 items-center justify-center backdrop-blur-sm opacity-0 group-hover:opacity-100 ${className}`} aria-label="Previous image"><ChevronLeft className="w-5 h-5 md:w-6 md:h-6" /></button>;
    $[0] = canGoPrevious;
    $[1] = className;
    $[2] = onPrevious;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== canGoNext || $[5] !== className || $[6] !== onNext) {
    t2 = canGoNext && <button type="button" onClick={e_1 => {
      e_1.preventDefault();
      e_1.stopPropagation();
      e_1.nativeEvent.stopImmediatePropagation();
      onNext();
    }} onMouseDown={_temp2} className={`flex absolute right-2 md:right-4 top-1/2 -translate-y-1/2 z-10 bg-black/10 hover:bg-black/30 text-white rounded-full p-2 md:p-3 shadow-lg transition-all duration-200 items-center justify-center backdrop-blur-sm opacity-0 group-hover:opacity-100 ${className}`} aria-label="Next image"><ChevronRight className="w-5 h-5 md:w-6 md:h-6" /></button>;
    $[4] = canGoNext;
    $[5] = className;
    $[6] = onNext;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp2(e_2) {
  e_2.preventDefault();
  e_2.stopPropagation();
}
function _temp(e_0) {
  e_0.preventDefault();
  e_0.stopPropagation();
}